import {
  GetAppConfigByKeyRequest,
  GetAppConfigByKeyResponse,
} from '../../../models/app-config/get-app-config-by-key.model';
import {
  GetAppConfigRequest,
  GetAppConfigResponse,
} from '../../../models/app-config/get-app-config.model';
import { IAppConfigRepo } from '../../interfaces/app-config.interface';
import { privateApi as api } from '../../../../api/backend/config';
import { GetAppConfigCryptoNetworksResponse } from 'core/models/app-config/network/get-networks.models';
import {
  GetAppConfigCryptoNetworkByIdRequest,
  GetAppConfigCryptoNetworkByIdResponse,
} from 'core/models/app-config/network/get-network-by-id.model';
import {
  GetDiscordPulseRequest,
  GetDiscordPulseResponse,
} from 'core/models/app-config/get-discord-pulse.model';
import { GetOpenAiMessageRequest } from 'core/models/app-config/get-openai-result.model';
export class AppConfigV1BaseServerRepo implements IAppConfigRepo {
  private readonly repoUrl =
    process.env.REACT_APP_REPOSITORY_BASESERVER + '/api/v1/app-config';

  public async getAll(
    request: GetAppConfigRequest
  ): Promise<GetAppConfigResponse> {
    const url = this.repoUrl;

    const response = await api.get(url, { params: request });

    return response.data;
  }

  public async getByKey(
    request: GetAppConfigByKeyRequest
  ): Promise<GetAppConfigByKeyResponse> {
    const url = this.repoUrl + '/' + request.key;

    const response = await api.get(url);

    return { [request.key]: response.data };
  }

  public async getCryptoNetworks(): Promise<GetAppConfigCryptoNetworksResponse> {
    const url = this.repoUrl + '/networks';

    const response = await api.get(url);

    return response.data.data;
  }

  public async getCryptoNetworkById(
    request: GetAppConfigCryptoNetworkByIdRequest
  ): Promise<GetAppConfigCryptoNetworkByIdResponse> {
    const url = this.repoUrl + `/networks/${request.id}`;

    const response = await api.get(url);

    return response.data;
  }

  public async getDiscordPulse(
    params: GetDiscordPulseRequest
  ): Promise<GetDiscordPulseResponse> {
    const url = this.repoUrl + '/discordPulse';
    const response = await api.get(url, { params });
    return response.data;
  }

  public async getOpenAiThread(): Promise<string> {
    const url = this.repoUrl + '/thread';
    const response = await api.post(url);
    return response.data;
  }

  public async getOpenAiMessage(
    request: GetOpenAiMessageRequest
  ): Promise<string> {
    const url = this.repoUrl + '/message';
    const response = await api.post(url, request);
    return response.data;
  }
}
